import { ReactNode, useState } from "react";
import { InstallLockdownModalContent, InstallMobileModalContent } from "@verity/components";
import { CoreModal } from "@verity/components/core";
import { getLockdownDownloadUrl } from "../../helpers/download";
import { launchLockdown, LockdownLaunchInfo, MobileLaunchInfo } from "../start-assessment";

export function useLaunchLockdownModal(): {
	modal: ReactNode;
	setLaunchInfo: (info?: LockdownLaunchInfo) => void;
} {
	const [launchInfo, setLaunchInfo] = useState<LockdownLaunchInfo | undefined>();
	return {
		modal: launchInfo ? (
			<CoreModal open onClose={() => setLaunchInfo(undefined)} showBottomCloseButton>
				<InstallLockdownModalContent
					quizUrl={launchInfo.target}
					launchLockdown={() => launchLockdown(launchInfo)}
					getDownloadLink={getLockdownDownloadUrl}
				/>
			</CoreModal>
		) : null,
		setLaunchInfo,
	};
}

export function useLaunchMobileModal(): {
	modal: ReactNode;
	setLaunchInfo: (info?: LockdownLaunchInfo) => void;
} {
	const [launchInfo, setLaunchInfo] = useState<MobileLaunchInfo | undefined>();
	return {
		modal: launchInfo ? (
			<CoreModal open onClose={() => setLaunchInfo(undefined)} showBottomCloseButton minWidth="95%">
				<InstallMobileModalContent assessmentUrl={launchInfo.target} />
			</CoreModal>
		) : null,
		setLaunchInfo,
	};
}
